import * as Logger from "js-logger";
import { SkipSpinCommand } from "slotworks/commands/comms/skip-spin-command";
import { StopSpinCommand } from "slotworks/commands/comms/stop-spin-command";
import { FatalErrorCommand } from "slotworks/commands/error/fatal-error-command";
import Components from "slotworks/components/components";
import LandSoundsMediator from "slotworks/mediators/land-sounds-mediator";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SettingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import State from "slotworks/state-machine/states/state";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import betModel from "slotworks/model/bets/bet-model";
import wrapperMediator from "slotworks/integration/revolver/wrapper/wrapper-mediator";
import translations from "slotworks/i18n/translations";

export default class Spin extends State {

    private skipping: boolean;

    private landSoundsMediator: LandSoundsMediator;

    protected inFreespins: boolean;
    protected hasBonus: boolean;

    public onEnter() {
        this.skipping = false;
        this.inFreespins = false;

        this.landSoundsMediator = new LandSoundsMediator();
        this.landSoundsMediator.start().execute();

        const record: SpinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;

        const elapsedTime = Date.now() - Components.matrix.getStartTime();
        if(this.needDelay(record) && elapsedTime < SettingsModel.midSpinTime) {
            setTimeout(() => StopSpinCommand(record, SettingsModel.getQuickSpin()).then(() => this.complete()), SettingsModel.midSpinTime - elapsedTime);
        } else {
            StopSpinCommand(record, SettingsModel.getQuickSpin()).then(() => this.complete());
        }

        if(CampaignsModel.shouldUpdateDisplay())
        {
            Components.promoBetBar.setRemainingSpins(CampaignsModel.freespins.remaining,CampaignsModel.freespins.total);
        }
    }

    public onSkip() {
        if(SettingsModel.isSkipDisabled() && !this.inFreespins)
            return;
        if(!this.inFreespins && Date.now() - Components.matrix.getStartTime() < SettingsModel.minSkipTime)
            return;
        if (!this.skipping) {
            this.skipping = true;
            const record: SpinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
            SkipSpinCommand(record).then(() => this.skip());
        }
    }

    public onExit() {
        const brokenSymbols = [];
        const record = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        for (const symbol of Components.matrix.getGridSymbols()) {
            if (symbol.gridPosition.y > 0 && symbol.gridPosition.y < record.grid.length) {
                if (symbol.symbolId !== record.grid[symbol.gridPosition.x - 1][symbol.gridPosition.y - 1]) {
                    brokenSymbols.push(symbol);
                }
            }
        }
        if (brokenSymbols.length) {
            FatalErrorCommand(translations.get("@err_server_generic"));
            Logger.error(brokenSymbols);
        }

        this.landSoundsMediator.end();
        const bet = GameState.getCurrentGame().inFreespinsGame ? 0 : betModel.getTotalBet();
        wrapperMediator.roundEnd(record.creditsWon, bet, GameState.getCurrentGame().balance);
    }

    protected needDelay(record: SpinRecord) {
        this.inFreespins = record instanceof FreespinRecord;
        const anticipation = this.hasAnticipation(record);
        this.hasBonus = this.isBonusTriggered(record);
        if(SettingsModel.midSpinTime > 0) {
            if(!this.inFreespins && !anticipation && !this.hasBonus)
                return true;
        }
        return false;
    }

    protected hasAnticipation(record:SpinRecord) {
        if(record.anticipations && record.anticipations.reelAnticipations) {
            for(let anticipation of record.anticipations.reelAnticipations) {
                if(anticipation)
                    return true;
            }
        }
        return false;
    }

    protected isBonusTriggered(record: SpinRecord): boolean {
        for (const result of record.results) {
            if (result instanceof BonusResult) {
                if (!result.played) {
                    return true;
                }
            }
        }
        if(record.gameName && record.gameName.toUpperCase() != "$BASE")
            return true;
        return false;
    }

    public complete() {
        const elapsedTime = Date.now() - Components.matrix.getStartTime();
        if(!this.inFreespins && !this.hasBonus && elapsedTime < SettingsModel.minSpinTime) {
            setTimeout(() => super.complete(), SettingsModel.minSpinTime - elapsedTime);
        } else
            super.complete();
    }


}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/spin.ts